export enum RangeConfigKey {
  MessagingSearchRange = "messaging_search_range",
}